import cn from 'classnames';
import React, { useEffect, useReducer } from 'react';
import styles from './WinMessages.scss';

// MANAGERS
import { useAppSelector } from '@Managers/Redux/Hooks';

import { EDebugWinPresentationEvents } from '@Core/Win/States/WinPresentationStates';
import EventsCenter from '@Managers/Events/EventsCenter';
import { getDebugWinPresentationModeState, getOfAKind } from '@Managers/Redux/AppState/AppState';

interface IComponentState {
    xKindIndex: number | undefined;
    debugAvailable: boolean;
}

const WinMessagesofAKindModifier: React.FC = () => {
    const [state, setState] = useReducer((s: IComponentState, ns: Partial<IComponentState>) => ({ ...s, ...ns }), {
        xKindIndex: undefined,
        debugAvailable: false
    });
    const gameStoreDebugWinPresentationModeState = useAppSelector(getDebugWinPresentationModeState);
    const gameStoreOfAKind = useAppSelector(getOfAKind);
    const availableModifiers: number[] = gameStoreOfAKind || [];

    useEffect(() => {
        setState({ debugAvailable: gameStoreDebugWinPresentationModeState.available });
    }, [gameStoreDebugWinPresentationModeState.available]);

    function handleAKindModifier(index: number) {
        if (state.xKindIndex === index) {
            EventsCenter.emit(EDebugWinPresentationEvents.DEBUG_WINPRESENTATION_5OFAKIND_CHANGE, undefined);
            setState({ xKindIndex: undefined });
        } else {
            EventsCenter.emit(EDebugWinPresentationEvents.DEBUG_WINPRESENTATION_5OFAKIND_CHANGE, { ofAKindModifier: index });
            setState({ xKindIndex: index });
        }
    }

    return (
        <div className={styles.winMessages_levels_group}>
            <div className={styles.winMessages_header}>ofAKindModifier</div>

            <div className={styles.winMessages_levels}>
                {availableModifiers.map((kindValue) => {
                    return (
                        <div
                            key={kindValue}
                            onClick={() => handleAKindModifier(kindValue)}
                            className={cn(styles.winMessages_levelItem, state.xKindIndex === kindValue ? styles.clicked : null, {
                                [styles.disabled]: !state.debugAvailable
                            })}
                        >
                            {`${kindValue}_OF_A_KIND`}
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default WinMessagesofAKindModifier;
